import React from "react";
import { Box, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import colors from "../../styles/colors";
import { COLORS } from "../../styles/uiConstants";

/**
 * Tüm menülerde kullanılacak standart checkbox.
 * formFieldStyles ile uyumlu renkler.
 *
 * Opt-in: `palette` (işaretli renk klinik temasından), `fullWidth` (etiket
 * satırı boydan boya tıklanabilir), `controlSx` / `labelSx` (yalnızca kutuya /
 * yalnızca etiket sarmalayıcısına stil). `sx` eskisi gibi ikisine birden uygulanır.
 * `loading`: kaydedilirken kutunun yerinde aynı boyutta dönen halka gösterilir.
 */
export default function FormCheckbox({
  label,
  checked,
  onChange,
  disabled = false,
  palette,
  fullWidth = false,
  loading = false,
  controlSx = {},
  labelSx = {},
  sx = {},
  ...rest
}) {
  return (
    <FormControlLabel
      disabled={disabled || loading}
      control={
        loading ? (
          <Box sx={{ width: 42, height: 42, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CircularProgress size={18} thickness={5} sx={{ color: palette?.primary || colors.primary }} />
          </Box>
        ) : (
          <Checkbox
            checked={!!checked}
            onChange={(e) => onChange?.(e.target.checked)}
            disabled={disabled}
            sx={{
              color: COLORS.slate400,
              "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                color: palette?.primary || colors.primary,
              },
              "&.Mui-disabled": {
                color: COLORS.slate300,
              },
              ...sx,
              ...controlSx,
            }}
            {...rest}
          />
        )
      }
      label={
        typeof label === "string" ? (
          <Typography variant="body2" sx={{ fontWeight: 600, color: COLORS.slate600 }}>
            {label}
          </Typography>
        ) : (
          label
        )
      }
      sx={{ m: 0, ...(fullWidth ? { width: "100%", mr: 0 } : {}), ...sx, ...labelSx }}
    />
  );
}
